module.exports = __webpack_public_path__ + "img/PC3.ddc4db6d.png";